// extracted by mini-css-extract-plugin
export default {"root":"SuggestPlaceholderRow-root_it8fj"};